import { supabase, DoctorBreak } from '../lib/supabase';
import { getTenantId } from '../contexts/TenantContext';

export const doctorBreakService = {
  async getAll(): Promise<DoctorBreak[]> {
    const tenantId = getTenantId();
    const { data, error } = await supabase
      .from('doctor_breaks')
      .select(`
        *,
        doctor:doctors(*),
        schedule:doctor_schedules(*)
      `)
      .eq('tenant_id', tenantId)
      .is('deleted_at', null)
      .order('created_at', { ascending: false });

    if (error) throw error;
    return data || [];
  },

  async getByDoctorId(doctorId: string): Promise<DoctorBreak[]> {
    const tenantId = getTenantId();
    const { data, error } = await supabase
      .from('doctor_breaks')
      .select(`
        *,
        doctor:doctors(*),
        schedule:doctor_schedules(*)
      `)
      .eq('tenant_id', tenantId)
      .eq('doctor_id', doctorId)
      .eq('status', 'active')
      .is('deleted_at', null)
      .order('created_at', { ascending: false });

    if (error) throw error;
    return data || [];
  },

  async getById(id: string): Promise<DoctorBreak | null> {
    const tenantId = getTenantId();
    const { data, error } = await supabase
      .from('doctor_breaks')
      .select(`
        *,
        doctor:doctors(*),
        schedule:doctor_schedules(*)
      `)
      .eq('id', id)
      .eq('tenant_id', tenantId)
      .is('deleted_at', null)
      .single();

    if (error) throw error;
    return data;
  },

  async create(breakData: Omit<DoctorBreak, 'id' | 'tenant_id' | 'created_at' | 'updated_at' | 'deleted_at' | 'doctor' | 'schedule'>): Promise<DoctorBreak> {
    const tenantId = getTenantId();
    const { data, error } = await supabase
      .from('doctor_breaks')
      .insert({ ...breakData, tenant_id: tenantId })
      .select(`
        *,
        doctor:doctors(*),
        schedule:doctor_schedules(*)
      `)
      .single();

    if (error) throw error;
    return data;
  },

  async update(id: string, breakData: Partial<DoctorBreak>): Promise<DoctorBreak> {
    const tenantId = getTenantId();
    const { data, error } = await supabase
      .from('doctor_breaks')
      .update(breakData)
      .eq('id', id)
      .eq('tenant_id', tenantId)
      .select(`
        *,
        doctor:doctors(*),
        schedule:doctor_schedules(*)
      `)
      .single();

    if (error) throw error;
    return data;
  },

  async delete(id: string): Promise<void> {
    const tenantId = getTenantId();
    const { error } = await supabase
      .from('doctor_breaks')
      .update({ deleted_at: new Date().toISOString() })
      .eq('id', id)
      .eq('tenant_id', tenantId);

    if (error) throw error;
  }
};
